
// 插件路由
const feedback = () => import(/* webpackChunkName: "feedback" */ '~/addon/feedback/pages/feedback.vue')

const routes = [
	{ 
        path: '/feedback', 
        component: feedback 
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/feedback/router/index.js